"use client";

import { AddIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  IconButton,
  SimpleGrid,
  VStack
} from "@chakra-ui/react";
import { FieldArray, useFormikContext } from "formik";
import CustomInput from "../../../../../../config/component/CustomInput/CustomInput";

const EEFCExportsSection = ({ showError }: any) => {
  const { values, setFieldValue, errors, touched }: any = useFormikContext();
  // template for a new row
  const emptyRow = {
    utilizationAmount: "",
    netConversionRate: "",
  };

  // Recalculate per-row net settlement rate
  const calculateNetSettlementRate = (row: any) => {
    const hedge = parseFloat(row.hedgeRate) || 0;
    const premium = parseFloat(row.forwardPremium) || 0;
    const cashTom = parseFloat(row.cashTomSpot) || 0;

    const net = hedge + premium + cashTom;
    return net ? net.toFixed(4) : "0.0000";
  };

  // When any field changes
  // const handleChange = (index: number, field: string, value: any) => {
  //   let updatedRow = { ...values.eefcExportsList[index], [field]: value };

  //   // recalc net settlement rate
  //   updatedRow.netConversionRate = calculateNetSettlementRate(updatedRow);

  //   setFieldValue(`eefcExportsList.${index}`, updatedRow);
  // };

  const handleChange = (index: number, field: string, value: any) => {
  // 1. Create the updated row with the new value
  let updatedRow = { ...values.eefcExportsList[index], [field]: value };

  // 2. Only auto-calculate IF the field changed isn't the rate itself
  // If we ARE changing the rate, we skip the calculation and keep the user's input
  if (field !== "netConversionRate") {
    updatedRow.netConversionRate = calculateNetSettlementRate(updatedRow);
  }

  setFieldValue(`eefcExportsList.${index}`, updatedRow);
};

  return (
    <Box
      p={5}
      borderWidth="1px"
      borderColor="green.200"
      bg="green.50"
      rounded="lg"
    >
      <Flex justify="space-between" mb={4}>
        <Box fontWeight={700} fontSize="lg" color="green.700">
          EEFC Conversion – Exports
        </Box>

        <FieldArray name="eefcExportsList">
          {({ push }) => (
            <Button
              leftIcon={<AddIcon />}
              variant="outline"
              colorScheme="green"
              size="sm"
              onClick={() => push(emptyRow)}
            >
              Add EEFC Export Row
            </Button>
          )}
        </FieldArray>
      </Flex>

      <FieldArray name="eefcExportsList">
        {({ remove }) => (
          <VStack spacing={4}>
            {values.eefcExportsList?.map((row: any, index: number) => {
              const rowTouched = touched?.eefcExportsList?.[index] || {};
              const rowErrors = errors?.eefcExportsList?.[index] || {};

              return (
                <Box
                  key={index}
                  p={4}
                  bg="white"
                  rounded="md"
                  shadow="sm"
                  w="full"
                  position="relative"
                >
                  <SimpleGrid columns={[1, 2, 2]} spacing={4}>

                    <CustomInput
                      label="Utilization Amount"
                      placeholder="Enter Utilization Amount"
                      name={`eefcExportsList.${index}.utilizationAmount`}
                      type="number"
                      value={row.utilizationAmount}
                      onChange={(e: any) =>
                        handleChange(
                          index,
                          "utilizationAmount",
                          e.target.value
                        )
                      }
                      error={
                        rowTouched.utilizationAmount &&
                        rowErrors.utilizationAmount
                      }
                      showError={showError}
                    />

                    <CustomInput
  label="Net Conversion Rate"
  placeholder="0.0000"
  name={`eefcExportsList.${index}.netConversionRate`}
  type="number" 
  value={row.netConversionRate}
  // Add this onChange handler:
  onChange={(e: any) =>
    handleChange(
      index,
      "netConversionRate",
      e.target.value
    )
  }
  error={rowTouched.netConversionRate && rowErrors.netConversionRate}
  showError={showError}
/>
                        {/* <CustomInput
                       label="Net Conversion Rate"

                       type="number"
                       placeholder="Net Conversion Rate"
                       name={`eefcExportsList.${index}.netConversionRate`}
                       value={row.netConversionRate}
                     /> */}
                  </SimpleGrid>

                  {values.eefcExportsList.length > 1 && (
                    <IconButton
                      aria-label="Delete row"
                      icon={<DeleteIcon />}
                      size="sm"
                      colorScheme="red"
                      position="absolute"
                      top={2}
                      right={2}
                      onClick={() => remove(index)}
                    />
                  )}
                </Box>
              );
            })}
          </VStack>
        )}
      </FieldArray>
    </Box>
  );
};

export default EEFCExportsSection;
